<template>
    <ProspectSearchLayout :mini="false" :prospectSearch="false">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <nav aria-label="breadcrumb" role="navigation" class="m-0">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{ name: 'Search' }">Home</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{ name: 'ProspectSearch' }">Prospect List</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Access List</li>
                </ol>
            </nav>
        </div>
        <div class="prospect_content">
            <div class="prospect_result">
                <div class="section_head">
                    <div class="md-layout md-alignment-top-right">
                        <div class="md-layout-item md-size-75 p-0">
                            <h2 class="section_header m-0">Access List</h2>
                            <span v-if="nameListSpan">{{ nameListSpan }}</span>
                        </div>
                        <div class="md-layout-item p-0">
                            <div  class="align-div-components">
                                <div>
                                    <md-table table-header-color="white" class="profit-and-loss-table">
                                        <md-table-row class="md-table-side-label table-header">
                                            <md-table-cell colspan="3">CREDITS</md-table-cell>
                                        </md-table-row>
                                        <md-table-row class="md-table-side-label table-header">
                                            <md-table-cell>Available</md-table-cell>
                                            <md-table-cell>Total</md-table-cell>
                                            <md-table-cell>Used</md-table-cell>
                                        </md-table-row>
                                        <md-table-row class="table-content-credits">
                                            <md-table-cell>{{ this.separator(this.creditsAvailable) }}</md-table-cell>
                                            <md-table-cell>{{ this.separator(this.creditsTotal) }}</md-table-cell>
                                            <md-table-cell>{{ this.separator(this.creditsUsed) }}</md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <md-card>
                    <md-card-header>
                        <md-button @click="comeBackToProspectSearch()" class="back_button">
                            <md-icon>keyboard_double_arrow_left</md-icon>Back
                        </md-button>
                    </md-card-header>
                    <md-card-content>
                        <div class="result_info">
                            <h1>
                                You have data of total
                                <br />
                                {{ this.totalResult }} companies to purchase
                            </h1>
                            <p>Please choose any of the following option</p>
                        </div>
                        <div class="action_wpr">
                            <md-button v-if="isRetail" @click="buyCreditsModal = true">
                                Buy More Credits
                                <md-icon>keyboard_double_arrow_right</md-icon>
                            </md-button>
                            <md-button v-if="!saveListForLater" @click="showAddList">
                                Save List For Later
                                <md-icon>keyboard_double_arrow_right</md-icon>
                            </md-button>
                            <md-button @click="showPartialList">
                                Prospect Partial List
                                <md-icon>keyboard_double_arrow_right</md-icon>
                            </md-button>
                            <md-button @click="showFulList">
                                Prospect Full List
                                <md-icon>keyboard_double_arrow_right</md-icon>
                            </md-button>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
            <modal v-if="addList" @close="addList = false">
                <template slot="header">
                    <h3 class="modal-title">Saved Lists</h3>
                    <button type="button" class="close_btn" @click="addList = false">
                        <md-icon>clear</md-icon>
                    </button>
                </template>
                <template slot="body">
                    <div class="field_wpr">
                        <div class="input_wpr">
                            <input aria-label="name" type="text" v-model="nameList" placeholder="Enter name of your list" />
                        </div>
                        <md-button @click="saveList()">Save List</md-button>
                    </div>
                </template>
            </modal>
            <modal v-if="partialList" @close="partialList = false">
                <template slot="header">
                    <h3 class="modal-title">Prospect Partial List</h3>
                    <p>Enter number of companies data you want to {{ isRetail ? "buy" : "access" }} out of {{
                            this.totalResult
                    }}</p>
                    <button type="button" class="close_btn" @click="partialList = false">
                        <md-icon>clear</md-icon>
                    </button>
                </template>
                <template slot="body">
                    <div class="field_wpr">
                        <div class="input_wpr">
                            <input aria-label="number" type="number" placeholder="Enter the number of companies" v-model="purchaseData" />
                            <button type="button" class="clear_btn" @click="clearData" v-if="clear">
                                <md-icon>close</md-icon>
                            </button>
                        </div>
                        <md-button @click="prospectPartialList(false)">Calculate</md-button>
                    </div>
                </template>
                <div class="div-pulse-loaded">
                    <PulseLoader :loading="loaded" :quote="true" class="pulse-loaded"></PulseLoader>
                </div>
                <template slot="footer">
                    <div v-if="loaded" class="div-pulse-loaded">
                        <PulseLoader :loading="loaded" :quote="true" class="pulse-loaded"></PulseLoader>
                    </div>
                    <div v-else class="div-price-partial">
                        <div class="price_amt" v-if="price">
                            <div v-if="!this.isRetail || this.creditsAvailable">
                                <div v-if="this.creditsAvailable < parseFloat(this.totalResult.replace(/,/g, ''))">
                                    <h4>
                                        Insufficient credits, total:
                                        <span>{{ this.totalResult }}</span>
                                        <md-button class="pay_btn" @click="buyCreditsModal = true">Buy Credits
                                        </md-button>
                                    </h4>
                                </div>
                                <div v-else>
                                    <h4>
                                        Used credits:
                                        <span>{{ this.totalResult }}</span>
                                        <md-button @click="payNow(true)" :disabled="processing" :class="processing ? 'pay_btn no-click' : 'pay_btn'">{{ processing ? 'Processing…' : 'Access Now' }}</md-button>
                                    </h4>
                                </div>
                            </div>
                            <div v-else>
                                <h4>
                                    Your price is
                                    <span>{{ this.priceList }} USD</span>
                                    <md-button @click="payNow(true)"
                                        :class="processing ? 'pay_btn non-subscriber no-click' : 'pay_btn'"> {{
                                                processing ? 'Processing' : 'Pay Now'
                                        }}</md-button>
                                </h4>
                                <p>
                                    Complete the payment and
                                    <u>start accessing</u>
                                    the {{ this.totalResult }} companies data
                                </p>
                            </div>
                        </div>
                        <ul v-else>
                            <li>
                                <h5>Total Prospect</h5>
                                <h4>{{ this.totalResult }}</h4>
                            </li>
                            <li>
                                <h5>Already Accessed</h5>
                                <h4>{{ this.alreadyAccessed }}</h4>
                            </li>
                            <li>
                                <h5>Total Available</h5>
                                <h4>{{ this.totalAvailable }}</h4>
                            </li>
                        </ul>
                        <ul v-if="!this.isRetail || this.creditsAvailable">
                            <li>
                                <h5>Credits Available</h5>
                                <h4>{{ this.separator(this.creditsAvailable) }}</h4>
                            </li>
                            <li>
                                <h5>Total Credits</h5>
                                <h4>{{ this.separator(this.creditsTotal) }}</h4>
                            </li>
                            <li>
                                <h5>Credits Used</h5>
                                <h4>{{ this.separator(this.creditsUsed) }}</h4>
                            </li>
                        </ul>
                    </div>
                </template>
            </modal>
            <modal v-if="fulList" @close="fulList = false">
                <template slot="header">
                    <h3 class="modal-title">Prospect Full List</h3>
                    <p>
                        You have {{ this.totalResult }} companies data
                        <br />Please check below
                    </p>
                    <button type="button" class="close_btn" @click="fulList = false">
                        <md-icon>clear</md-icon>
                    </button>
                </template>

                <template slot="footer">
                    <div v-if="loaded" class="div-pulse-loaded">
                        <PulseLoader :loading="!loaded" :quote="true" class="pulse-loaded"></PulseLoader>
                    </div>
                    <div v-else class="div-price-partial">
                        <div class="price_amt">
                            <div v-if="!this.isRetail || this.creditsAvailable">
                                <div v-if="this.creditsAvailable < parseFloat(this.totalResult.replace(/,/g, ''))">
                                    <h4>
                                        Insufficient credits, total:
                                        <span>{{ this.totalResult }}</span>
                                        <md-button class="pay_btn" @click="buyCreditsModal = true">Buy Credits
                                        </md-button>
                                    </h4>
                                </div>
                                <div v-else>
                                    <h4>
                                        Used credits:
                                        <span>{{ this.totalResult }}</span>
                                        <md-button @click="payNow(false)" :disabled="processing" :class="processing ? 'pay_btn no-click' : 'pay_btn'">{{ processing ? 'Processing…' : 'Access Now' }}</md-button>
                                    </h4>
                                </div>
                            </div>
                            <div v-else>
                                <h4>
                                    Your price is
                                    <span>{{ this.priceList }} USD</span>
                                    <md-button @click="payNow(false)"
                                        :class="processing ? 'pay_btn non-subscriber no-click' : 'pay_btn'"> {{
                                                processing ? 'Processing' : 'Pay Now'
                                        }}</md-button>
                                </h4>
                                <p>
                                    Complete the payment and
                                    <u>start accessing</u>
                                    the {{ this.totalResult }} companies data
                                </p>
                            </div>
                        </div>
                        <ul v-if="!this.isRetail || this.creditsAvailable">
                            <li>
                                <h5>Credits Available</h5>
                                <h4>{{ this.separator(this.creditsAvailable) }}</h4>
                            </li>
                            <li>
                                <h5>Total Credits</h5>
                                <h4>{{ this.separator(this.creditsTotal) }}</h4>
                            </li>
                            <li>
                                <h5>Credits Used</h5>
                                <h4>{{ this.separator(this.creditsUsed) }}</h4>
                            </li>
                        </ul>
                    </div>
                </template>
            </modal>
            <modal v-if="buyCreditsModal" @close="buyCreditsModal = false">
                <template slot="header">
                    <h3 class="modal-title">Buy Credits</h3>
                    <button type="button" class="close_btn" @click="buyCreditsModal = false">
                        <md-icon>clear</md-icon>
                    </button>
                </template>
                <template slot="body">
                    <div class="field_wpr">
                        <div class="input_wpr">
                            <div class="border-none">
                                <md-field>
                                    <md-select v-model="credit" name="category">
                                        <md-option v-for="(option, key) in optionsCredit" :key="key" :label="option"
                                            :value="key">{{ option }}</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <md-button @click="buyCredits" class="md-info md-round margin-button-buy">Buy</md-button>
                    </div>
                </template>
            </modal>
        </div>
    </ProspectSearchLayout>
</template>
<script>
import ProspectSearchLayout from '@/pages/Layout/ProspectSearchLayout';
import { Modal, PulseLoader } from '@/components';
import { mapState } from 'vuex';
import axios from 'axios';

export default {
    name: 'SearchList',
    components: {
        ProspectSearchLayout,
        Modal,
        PulseLoader,
    },
    data() {
        return {
            buyCreditsModal: false,
            saveListForLater: this.$store.getters.psIsSaved,
            addList: false,
            partialList: false,
            fulList: false,
            purchaseData: null,
            price: false,
            clear: false,
            nameList: null,
            nameListSpan: this.$store.getters.psName,
            totalResult: this.separator(this.$route.params.total),
            listId: this.$route.params.id,
            priceList: 0,
            priceFull: this.separator(parseFloat(this.$store.getters.psPrice).toFixed(2)),
            alreadyAccessed: 0,
            totalAvailable: 0,
            loaded: false,
            newListIdReturned: null,
            credit: 0,
            optionsCredit: {
                '0': 'Select the credits',
                '500': '500 credits ($150)',
                '1000': '1,000 credits ($275)',
                '2500': '2,500 credits ($500)',
                '5000': '5,000 credits ($750)',
            },
            processing: false,
        }
    },
    computed: {
        ...mapState({
            creditsAvailable: (state) => state.prospectSearch.psCreditsAvailable,
            creditsTotal: (state) => state.prospectSearch.psCreditsTotal,
            creditsUsed: (state) => state.prospectSearch.psCreditsUsed,
            isRetail: (state) => (state.user.user_type.retail/* || state.user.allow_retail*/) ?true: null,
        }),
    },

    methods: {
        buyCredits: function () {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            axios
                .post(
                    process.env.VUE_APP_API_BASE_URL + '/user/cart/add_credits',
                    {},
                    {
                        params: {
                            session_id: currentSession,
                            credits: this.credit,
                        },
                    }
                )
                .then((res) => {
                    if (res.hasOwnProperty('data') && res.data.error) {
                        this.$store.commit('SET_ERROR_BIT', true);
                        this.$store.commit(
                            'SET_ERROR_INFO',
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode +
                            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/cart/add_credits" <br>`
                        );
                        throw new Error(
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode
                        );
                    }
                    else {
                        if (res.data.success) {
                            this.$router.push({
                                name: 'Cart',
                            });
                        }
                    }
                });
        },
        comeBackToProspectSearch: function () {
            this.$store.commit('PS_SET_FROM_REVENUE_MODEL', null);
            this.$store.commit('PS_SET_TO_REVENUE_MODEL', null);
            this.$store.commit('PS_SET_FROM_VALUE_MODEL', null);
            this.$store.commit('PS_SET_FROM_YEAR_MODEL', null);
            this.$store.commit('PS_SET_TO_YEAR_MODEL', null);
            this.$store.commit('PS_SET_TO_VALUE_MODEL', null);
            this.$store.commit('PS_SET_RADIO_SOCIAL_PRESENSE', null);
            this.$store.commit('PS_SET_RADIO_WEB_PRESENSE', null);
            this.$store.commit('PS_SET_RADIO_FRANCHISE', null);
            this.$store.commit('PS_SET_EMPLOYEE_COUNT', null);
            this.$store.commit('PS_SET_YEARS_IN_BUSINESS', null);
            this.$store.commit('PS_SET_CONTACT_STREET_ADDR', null);
            this.$store.commit('PS_SET_CONTACT_NAME', null);
            this.$store.commit('PS_SET_CONTACT_PHONE', null);
            this.$store.commit('SET_MARKET_AREA', null);
            this.$store.commit('SET_INDUSTRY', null);
            this.$store.commit('PS_SET_ID', null);
            this.$router.push({
                name: 'ProspectSearch',
            });
        },
        showAddList: function () {
            this.addList = true;
        },
        showPartialList: function () {
            this.partialList = true;
        },
        showFulList: function () {
            this.totalResult = this.separator(this.$route.params.total);
            this.priceList = this.priceFull;
            this.fulList = true;
        },
        showPrice: function () {
            if (this.purchaseData != null) {
                this.price = true;
                this.clear = true;
            }
        },
        clearData: function () {
            this.totalResult = this.separator(this.$route.params.total);
            this.purchaseData = null;
            this.price = false;
            this.clear = false;
            this.prospectPartialList();
        },
        saveList: function () {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            axios
                .post(
                    process.env.VUE_APP_API_BASE_URL + '/user/search_lists/nameCompanySavedList',
                    {},
                    {
                        params: {
                            session_id: currentSession,
                            //list_id: this.newListIdReturned ?? this.listId,
                            list_id: this.listId,
                            name: this.nameList,
                        },
                    }
                )
                .then((res) => {
                    if (res.hasOwnProperty('data') && res.data.error) {
                        this.$store.commit('SET_ERROR_BIT', true);
                        this.$store.commit(
                            'SET_ERROR_INFO',
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode +
                            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                        );

                        throw new Error(
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode
                        );
                    }
                    else {
                        this.addList = false;
                    }
                });
        },
        payNow: async function (isPartial) {
            if (this.processing) return; // block repeat clicks (7.19: button felt dead)
            this.processing = true;

            if (!this.savedListsReceived)
                this.loadedViewSavedList = true;

            let params = {
                product_id: isPartial ? this.newListIdReturned : this.listId
            };

            this.$store.commit('PS_SET_TOTAL_RESULT', this.totalResult);

            try {
                const res = await this.$store.dispatch('cart/accessProduct', params);

                // accessProduct swallows service-level rejections and returns undefined
                if (!res) {
                    this.$store.dispatch('alerts/error', 'Could not access the list. Please try again.');
                    return;
                }

                if (res.cart) {
                    this.$router.push({ name: 'Cart', params: { listId: params.product_id } });
                    return;
                }

                // Access granted, OR the list was already accessed. An already-accessed prospect
                // list comes back error:true with a LIST-specific errorCode (not the non-list
                // 'product_already_accessed'), which the old code didn't recognize -> the button
                // did nothing and gave no feedback. Route those to the companies list too.
                //
                // ONLY these two mean the purchase record genuinely exists already:
                // ProcessProspectListAccess's own array_key_exists() check is what returns
                // access_list_profile_id_count_already_set, so hitting it proves
                // counts_purchased already has this profile_id.
                const alreadyAccessed = res.error && [
                    'product_already_accessed',
                    'access_list_profile_id_count_already_set',
                ].includes(res.errorCode);

                if (res.access || alreadyAccessed) {
                    this.$router.push({ name: 'CompaniesList', params: { id: params.product_id } });
                    return;
                }

                // access_list_invalid_attempted_count / access_list_depleted mean the OPPOSITE --
                // ProcessProspectListAccess returned before ever writing counts_purchased for this
                // profile_id, so nothing was recorded. These used to be lumped in with
                // alreadyAccessed above and silently routed to CompaniesList anyway -- with no
                // count on record, that page has nothing to show, and the customer landed on a
                // list that looked purchased but was empty (found 2026-09-21: a "partial list"
                // request racing an in-flight access call for a sibling derived profile off the
                // same purchase -- count_purchase_attempt is one shared mutable scalar across
                // the whole derived-profile family, so the second request can see it already
                // reset to 0 by the first one's completion). Show a real error instead of a
                // silent blank page; don't touch the shared-scalar race itself here.
                if (res.error && res.errorCode === 'access_list_depleted') {
                    this.$store.dispatch('alerts/error', 'This list has no more companies available to access.');
                    return;
                }
                if (res.error && res.errorCode === 'access_list_invalid_attempted_count') {
                    this.$store.dispatch('alerts/error', 'Could not access the list right now. Please try again.');
                    return;
                }

                if (res.error) {
                    this.$store.dispatch('alerts/error', 'Unable to access list (' + (res.errorCode || 'unknown_error') + ').');
                }
            } catch (e) {
                this.$store.dispatch('alerts/error', 'Something went wrong accessing the list. Please try again.');
            } finally {
                this.processing = false;
            }
        },
        prospectPartialList: function (whenLoadModal) {

            if (whenLoadModal || this.convertToFloatWithNoComma(this.purchaseData) <= this.convertToFloatWithNoComma(this.$route.params.total)) {
                this.loaded = true;

                let currentSession = localStorage.getItem(
                    'vue-authenticate.vueauth_access_token'
                );
                axios
                    .post(
                        process.env.VUE_APP_API_BASE_URL + '/user/search_lists/companyFromExisting',
                        {},
                        {
                            params: {
                                session_id: currentSession,
                                list_id: this.listId,
                                count: this.purchaseData
                                    ? this.purchaseData
                                    : parseFloat(this.totalResult ? this.totalResult.replace(/,/g, '') : 0),
                            },
                        }
                    )
                    .then((res) => {
                        if (res.hasOwnProperty('data') && res.data.error) {
                            this.$store.commit('SET_ERROR_BIT', true);
                            this.$store.commit(
                                'SET_ERROR_INFO',
                                '<br>' +
                                'Server responded with error = True <br> errorCode: ' +
                                res.data.errorCode +
                                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                            );

                            throw new Error(
                                '<br>' +
                                'Server responded with error = True <br> errorCode: ' +
                                res.data.errorCode
                            );
                        }
                        else {

                            this.newListIdReturned = res.data.product_id;
                            this.alreadyAccessed = parseFloat(this.totalResult.replace(/,/g, '')) - res.data.count;
                            this.totalAvailable = res.data.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            this.priceFull = this.separator(parseFloat(res.data.price).toFixed(2));
                            if (this.purchaseData != null) {

                                this.priceList = this.separator(parseFloat(res.data.price).toFixed(2));
                                this.price = true;
                                this.clear = true;
                                this.totalResult = this.separator(this.purchaseData);
                            }
                            this.loaded = false;
                        }
                    });
            }
        },
        separator: function (number) {
            if (number) {
                var str = number.toString().split(".");
                str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return str.join(".");
            }
            return number;
        },
        convertToFloatWithNoComma: function (number) {
            if (number)
                return parseFloat(number.replace(/,/g, ''))
            return 0;
        },
    },
    mounted() {
        this.totalAvailable = parseFloat(this.totalResult.replace(/,/g, '')) - this.alreadyAccessed;
        this.totalAvailable = this.totalAvailable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

        if (!this.priceFull || this.priceFull == 'NaN')
            this.prospectPartialList(false);
    },
    watch: {
        partialList(newVal, oldVal) {

            /* if (!newVal)
                 this.clearData();*/
        },
    }
}
</script>
<style lang="scss">
.pulse-loaded {
    height: 40px !important;
}

.modal-footer {
    justify-content: center !important;
}

.div-price-partial {
    width: -webkit-fill-available;
}

.md-button.back_button {
    margin-right: auto !important;

    .md-icon {
        color: #3b7ef1 !important;
    }
}

.prospect_content .modal-mask .modal-container .modal-body .field_wpr .input_wpr .border-none input {
    border: none !important;
}

.margin-button-buy {
    margin-top: 0.8rem !important;
    margin-left: 1rem !important;
}

// .back-button-card-content{
//     padding:0!important;
// }
</style>